import "./App.css";
import Handler from "./components/artist-comment";

function App() {
  return (
    <>
      <Handler />
    </>
  );
}

export default App;
